import { useRouteError } from 'react-router';
import { NotFound } from 'web-components';

import {
  Flex,
} from 'web-styled';

export default function RouterErrorBoundary() {
  const error = useRouteError();

  return (
    <Flex fillSpace column align="center" justify="center">
      <Flex column spacing={15}>
        <NotFound title="Something went wrong! Please reload." />
        <details style={{ whiteSpace: 'pre-wrap' }}>
          {error instanceof Error ? error.message : JSON.stringify(error)}
        </details>
      </Flex>
    </Flex>
  );
}
